import { createContext, Dispatch, SetStateAction } from 'react'

export type ModalState =
  | 'CLOSED'
  | 'CREATE_ACCOUNT'
  | 'CREATE_ACCOUNT_ONLY_PASSWORD'
  | 'EMAIL_DECISION'
  | 'FORGOT_PASSWORD'
  | 'RESET_PASSWORD'
  | 'SIGN_IN'
  | 'VERIFY_EMAIL'

export interface ContextProps {
  check: ({
    checksum,
    customerID,
    email,
  }: {
    checksum?: string
    customerID?: string
    email?: string
  }) => Promise<{
    email?: string
    nextModalState: ModalState
    status?: string
  } | null>
  defaultEmail?: string
  forgotPassword: (email: string) => Promise<string | null>
  isLoggedIn: boolean
  isReady: boolean
  login: (username: string, password: string) => Promise<string | null>
  logout: () => Promise<string | null>
  modalState: ModalState
  passwordResetSuccess?: boolean
  register: (email: string, password: string, firstName: string, phonePrefix: string, phone: string) => Promise<{
    error?: string
    nextModalState?: ModalState
    status?: string
  } | null>
  resetPassword: (password: string) => Promise<string | null>
  setDefaultEmail: Dispatch<SetStateAction<string | undefined>>
  setModalState: Dispatch<SetStateAction<ModalState>>
  verifyEmail: (email: string) => Promise<string | null>
}

export const context = createContext<ContextProps>({
  check: async () => ({ nextModalState: 'CLOSED' }),
  forgotPassword: async () => null,
  login: async () => null,
  logout: async () => null,
  isLoggedIn: false,
  isReady: false,
  modalState: 'CLOSED',
  register: async () => null,
  resetPassword: async () => null,
  setDefaultEmail: () => {},
  setModalState: () => {},
  verifyEmail: async () => null,
})
